import React, { useContext, useEffect, useReducer, useState } from 'react'
import { Fragment } from 'react';
import { AuthContext } from '../../../App/App';
import { ContentBodyContext } from '../MainContent'
import { SRLWrapper } from "simple-react-lightbox";
import jwt from 'jwt-decode'
import axios from 'axios'
import qs from 'querystring'
import swal from 'sweetalert';

function WhatsappContact() {
    const { stateContentBody, dispatchContentBody } = useContext(ContentBodyContext);
    const { stateAuth, dispatchAuth } = useContext(AuthContext)
    const jwtHelpdesk = jwt(localStorage.getItem('token-helpdesk-umy'))

    const handleInputAdd = (e) => {
        if (e.target.validity.valid) {
            setdataForm({
                ...dataForm,
                tempWAContact: e.target.value,
                errWaContact: null
            })
        }
    }

    const handleSubmitAdd = (event, action) => {
        if (dataForm.tempWAContact != '') {
            const reqBody = {
                phone: dataForm.tempWAContact,
            }
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-access-token': localStorage.getItem('token-helpdesk-umy')
                }
            }

            axios.put(`/api/v1/helpdesk/setting/whatsapp/contact/${stateContentBody.whatsappContactId}`, qs.stringify(reqBody), config)
                .then(res => {
                    setdataForm({
                        ...dataForm,
                        waContact: action ? dataForm.waContact : dataForm.tempWAContact,
                        tempWAContact: action ? dataForm.tempWAContact : '',
                        disabled: true,
                        errWaContact: null
                    })

                    dispatchContentBody({
                        type: "WHATSAPP_CONTACT",
                        whatsappContactId: stateContentBody.whatsappContactId,
                        whatsappContact: dataForm.tempWAContact
                    })

                    swal("Success!", "Whatsapp number has been updated", "success", {
                        button: "OK",
                    });
                })
                .catch(err => {
                    if (!err.response || err.code === 'ECONNABORTED') {
                        swal("Error!", "Check Your Internet Connection!", "error", {
                            button: "OK",
                        });
                    } else if (err.response) {
                        if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                            dispatchAuth({
                                type: "LOGOUT",
                                message: 'Token expired, please login again...'
                            })
                        } else if (err.response.data.status === 'invalid') {
                            setdataForm({
                                ...dataForm,
                                errWaContact: err.response.data.errors[0].msg
                            })
                        } else {
                            swal("Error!", `${err.response.data.message}`, "error", {
                                button: "OK",
                            });
                        }
                    }
                })
        } else {
            setdataForm({
                ...dataForm,
                errWaContact: 'Please enter whatsapp number.'
            })
        }
    }

    const handleRestart = () => {
        stateContentBody.socket.emit(`whatsapp-restart`, {
            id: jwtHelpdesk.work_unit_id,
            token: localStorage.getItem('token-helpdesk-umy'),
            action: 'logout',
        })

        setdataForm({
            ...dataForm,
            logout: false
        })

        dispatchContentBody({
            type: "WA_STATUS",
            status: null,
            trigger: null
        })
    }

    const handleInputChange = (e) => {
        if (e.target.validity.valid) {
            setdataForm({
                ...dataForm,
                tempWAContact: e.target.value,
                errWaContact: null
            })
        }
    }
    const handlePhoneAction = (e, action) => {
        if (action == 'edit') {
            setdataForm({
                ...dataForm,
                disabled: false,
                errWaContact: null
            })
        } else if (action == 'save') {
            handleSubmitAdd(e, action)
        } else {
            setdataForm({
                ...dataForm,
                disabled: true,
                tempWAContact: dataForm.waContact,
                errWaContact: null
            })
        }
    }

    const handlsStatusAction = (e, action) => {
        if (action == 'restart') {
            setdataForm({
                ...dataForm,
                logout: true
            })
        } else if (action == 'yes') {
            handleRestart()
        } else {
            setdataForm({
                ...dataForm,
                logout: false
            })
        }
    }


    const initialDataForm = {
        waContact: stateContentBody.whatsappContact,
        tempWAContact: '',
        errWaContact: null,
        disabled: true,
        logout: false,
        status: "add"
    }
    const [dataForm, setdataForm] = useState(initialDataForm)
    useEffect(() => {
        if (stateContentBody.whatsappContact != null) {
            setdataForm({
                ...dataForm,
                waContact: stateContentBody.whatsappContact,
                tempWAContact: stateContentBody.whatsappContact
            })
        }
    }, [stateContentBody.whatsappContact])

    const initialRenderWhatsappContact = (
        <Fragment>
            <div className="empty-state-icon">
                <i className="fab fa-whatsapp" style={{ fontSize: '100px', color: 'green' }}></i>
            </div>
            <h2>We couldn't find whatsapp number</h2>
            <p className="lead">
                Sorry we can't find data, create new whatsapp number.
            </p>
        </Fragment>
    )
    const [renderWhatsappContact, setRenderWhatsappContact] = useState(initialRenderWhatsappContact)

    //QRCode update
    useEffect(() => {
        stateContentBody.socket.on(`qr-${jwtHelpdesk.work_unit_id}`, function (res) {
            dispatchQRCode({
                type: 'QRCODE',
                src: res.src
            })
        })
    }, [])

    const reducer = (state, action) => {
        switch (action.type) {
            case "QRCODE":
                return {
                    ...state,
                    src: action.src
                }
        }
    }
    const [qrcode, dispatchQRCode] = useReducer(reducer, { src: null })

    const [renderQR, setrenderQR] = useState(<Fragment />)
    useEffect(() => {
        if (stateContentBody.whatsappContact != null) {
            if (stateContentBody.whatsappAuth.status) {
                setrenderQR(
                    <Fragment>
                        <div className="empty-state-icon mb-5"><i className="fab fa-whatsapp" style={{ fontSize: '7em', color: 'green' }}></i></div>
                        <p>Whatsapp is ready to use, make sure that the phone remains connected to the internet</p>
                    </Fragment>
                )
            } else if (qrcode.src != null) {
                setrenderQR(
                    <Fragment>
                        <SRLWrapper>
                            <img className="gallery-item" src={qrcode.src} data-title="QRCode"></img>
                        </SRLWrapper>
                        <p>Click QR Code to enlarge image</p>
                    </Fragment>)
            } else {
                setrenderQR(
                    <Fragment>
                        <img className="gallery-item mb-3" style={{ maxWidth: '120px' }} src='./assets/img/whatsapp-icon-red.png' data-title="QRCode"></img>
                        <p>Load QR Code, Please Wait.... <i className="fas fa-spinner fa-pulse"></i></p>
                    </Fragment>)
            }
        }
    }, [stateContentBody.whatsappContact, stateContentBody.whatsappAuth, qrcode])

    useEffect(() => {
        if (dataForm.waContact == null || dataForm.waContact == '') {
            setRenderWhatsappContact(
                <Fragment>
                    <h2>We couldn't find whatsapp number</h2>
                    <p className="lead">
                        Sorry we can't find data, create new whatsapp number.
                    </p>
                    <div className="form-group row">
                        <label htmlFor="wa-contact" className="col-form-label">Phone Number</label>
                        <div className="input-group  has-validation mb-2">
                            <input pattern="[0-9]*" autoFocus type="text" value={dataForm.tempWAContact} className={`form-control ${dataForm.errWaContact != null ? 'is-invalid' : ''}`} id="wa-contact" name="wa-contact" onChange={handleInputAdd} placeholder="Whatsapp Number" aria-describedby="validationPhonenumber" />
                            <div className="input-group-append">
                                <button onClick={handleSubmitAdd} className="btn btn-success" type="button" style={{ textTransform: 'capitalize' }}>Add</button>
                            </div>
                            <div id="validationPhonenumber col-12" style={{ textAlign: 'start' }} className="invalid-feedback">
                                <small>{dataForm.errWaContact}</small>
                            </div>
                        </div>
                    </div>
                </Fragment>
            )
        } else if (dataForm.waContact != null) {
            setRenderWhatsappContact(
                <Fragment>
                    <div className="container">
                        <div className="row justify-content-md-center pt-3">
                            <div className="col-1 m-2" style={{ textAlign: 'start', fontWeight: 'bolder' }}>
                                Status
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-6">
                                <div className="form-group row">
                                    <div className="input-group  has-validation mb-4 col-12">
                                        <input autoFocus type="text" disabled className={`form-control ${dataForm.errWaContact != null ? 'is-invalid' : ''}`} id="wa-status" name="wa-status" style={{ textAlign: 'center' }} placeholder="Whatsapp Number" aria-describedby="validationStatus" value={dataForm.logout ? 'Are you sure ?' : (stateContentBody.whatsappAuth.status == null) ? '...Restarting' : (stateContentBody.whatsappAuth.status == true) ? 'Connected' : 'Disconnected'} />
                                        {!dataForm.logout ? (
                                            <div className="input-group-append">
                                                <button onClick={(e) => handlsStatusAction(e, 'restart')} className="btn btn-danger " type="button" style={{ textTransform: 'capitalize', width: '80px' }}>Restart</button>
                                            </div>
                                        ) : (
                                            <div className="row justify-content-md-center col-12 mt-3">
                                                <button onClick={(e) => handlsStatusAction(e, 'yes')} className="btn btn-danger mr-2" type="button" style={{ textTransform: 'capitalize', width: '80px' }}>Yes</button>
                                                <button onClick={(e) => handlsStatusAction(e, 'no')} className="btn btn-secondary ml-2" type="button" style={{ textTransform: 'capitalize', width: '80px' }}>No</button>
                                            </div>
                                        )}
                                        <div id="validationStatus col-12" style={{ textAlign: 'start' }} className="invalid-feedback">
                                            <small>{dataForm.errWaContact}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-md-center ">
                            <div className="col-1 m-2" style={{ textAlign: 'start', fontWeight: 'bolder' }}>
                                Number
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-6">
                                <div className="form-group row">
                                    <div className="input-group  has-validation mb-4 col-12">
                                        <input pattern="[0-9]*" autoFocus type="text" disabled={dataForm.disabled} value={dataForm.tempWAContact} className={`form-control ${dataForm.errWaContact != null ? 'is-invalid' : ''}`} id="wa-contact" name="wa-contact" style={{ textAlign: 'center' }} onChange={handleInputChange} placeholder="Whatsapp Number" aria-describedby="validationPhonenumber" />
                                        {dataForm.disabled ? (
                                            <div className="input-group-append">
                                                <button onClick={(e) => handlePhoneAction(e, 'edit')} className="btn btn-primary " type="button" style={{ textTransform: 'capitalize', width: '80px' }}>{dataForm.waContact == '' ? 'Add' : 'Edit'}</button>
                                            </div>
                                        ) : (
                                            <div className="row justify-content-md-center col-12 mt-4">
                                                <button onClick={(e) => handlePhoneAction(e, 'save')} className="btn btn-success mr-2" type="button" style={{ textTransform: 'capitalize', width: '80px' }}>Save</button>
                                                <button onClick={(e) => handlePhoneAction(e, 'cancel')} className="btn btn-secondary ml-2" type="button" style={{ textTransform: 'capitalize', width: '80px' }}>Cancel</button>
                                            </div>
                                        )}
                                        <div id="validationPhonenumber col-12" style={{ textAlign: 'start' }} className="invalid-feedback">
                                            <small>{dataForm.errWaContact}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            )
        }
    }, [dataForm, stateContentBody.whatsappAuth])

    return (
        <div className="col-12 col-md-12 col-lg-12">
            <div className="card" style={{ minHeight: '83vh' }}>
                <div className="card-body">
                    <div className="section-title mt-0 pb-4">
                        {stateAuth.page}
                    </div>
                    <div className="card-body">
                        <div className="empty-state mb-5 pb-5">
                            {renderQR}
                            {renderWhatsappContact}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WhatsappContact
